
import {
    Box
} from '@chakra-ui/react';
import { useSelector } from "react-redux";


import ServiceTimePerService from "../../components/organization/reports/ServiceTimePerService";
import _ from 'lodash';
import { getReportDescription } from '../../store/helpers';
import * as defaultSelectors from "../../store/selectors/defaultSelector";
import {
  SERVICE_TIME_PER_SERVICE_COLUMN_DEFINITIONS,
  getRenderConfigSummaryItems,
} from "../../store/renderConfig";

const ServiceTimePerServicePage = ({
  
  reportIndex = "**REPORT_INDEX**",
}) => {
  const reportRange = useSelector(defaultSelectors.selectReportRange);
  const reportsData = useSelector(defaultSelectors.selectReportsData);
  const renderConfig = useSelector(defaultSelectors.selectRenderConfig);
  const { data } = reportsData;

  console.log("INSIDE");
  

  const reportTitle = `${reportIndex}. Service Time Per Service`;
  const presentationSummaryItems = getRenderConfigSummaryItems(renderConfig, {
    columnDefinitions: SERVICE_TIME_PER_SERVICE_COLUMN_DEFINITIONS,
  });

  return (
    <Box>
      <Box mb="20px">
        <h1>{reportTitle}</h1>
        <p>{getReportDescription(reportRange).ServiceTimePerService}</p>
        {presentationSummaryItems.length ? (
          <div className="reportPresentationSummary">
            <strong>PRESENTATION</strong> {presentationSummaryItems.join(" / ")}
          </div>
        ) : null}
      </Box>
      {!_.isEmpty(data) ? (
        <ServiceTimePerService reportIndex={reportIndex} data={data} />
      ) : <Box mt={10}>
              <p>No data available in this report</p>
            </Box>}
    </Box>
  );
};

export default ServiceTimePerServicePage;
  
